export default {
      id: "bulb-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#bulb",
      toString: function () {
        return this.url;
      }
    }